import {getTrustAccountPath} from '@/features/trust-accounts/utils';

import type {GuestAccountInviter} from './guest-accounts.utils';
import type {TrustAccountListItem} from '@/features/trust-accounts/utils';
import type {GuestSharedTrustAccountDTO} from '@sollapay/types';

export interface GuestTrustAccountListItem extends TrustAccountListItem {
  invitedBy: GuestAccountInviter | null;
}

/** The balance comes with the guest list, so it is never `undefined` (still loading). */
export function toGuestListItem(account: GuestSharedTrustAccountDTO): GuestTrustAccountListItem {
  return {
    id: account.trustAccountId,
    refId: account.refId,
    name: account.trustAccountName,
    trustPurpose: account.trustPurpose,
    generalSaleTransactionType: account.generalSaleTransactionType,
    trustStatus: account.trustStatus,
    balance: account.balance?.balance ?? null,
    date: account.sharedAt,
    path: getTrustAccountPath({id: account.trustAccountId, trustStatus: account.trustStatus}),
    invitedBy: account.invitedBy
  };
}
